import { Stack, type StackProps, Typography } from '@mui/material';
import { ErrorIcon } from './ErrorIcon';

const unableToLoad = 'Unable to load page. Try again.';
const contactSupport =
  'If the problem persists, please contact the support team.';

interface Props extends StackProps {
  compact?: boolean;
}

export const GeneralError = ({ compact, ...props }: Props) => (
  <Stack
    {...props}
    sx={[
      {
        gap: 2,
        paddingInline: 2,
      },
      ...(Array.isArray(props.sx) ? props.sx : [props.sx]),
    ]}
  >
    <ErrorIcon color="error" sx={{ height: 36, margin: 'auto' }} />
    <Stack>
      <Typography
        variant="body1"
        color="error"
        sx={{
          textAlign: 'center',
        }}
      >
        {unableToLoad}
      </Typography>
      <Typography
        variant="body1"
        color="error"
        sx={{
          textAlign: 'center',
        }}
      >
        {contactSupport}
      </Typography>
    </Stack>
  </Stack>
);
